<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/targetResponsibility/personal' }">个人责任书
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.id ? "编辑" : "新增" }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="120px"
                    class="demo-ruleForm formBox"
                    size="small"
            >
                <el-form-item label="岗位责任书" prop="resTitle">
                    <el-select v-model="ruleForm.responsibleJobId" placeholder="请选择责任书" style="width: 100%"
                               @change="responseJobChange">
                        <el-option v-for="item0 in responsibleJobList" :key="item0.id" :label="item0.resTitle"
                                   :value="item0.id"/>
                    </el-select>
                </el-form-item>
                <el-form-item label-width="0" style="margin-bottom: 0">
                    <el-col :span="12">
                        <el-form-item label="部门" prop="resDepId">
                            <el-select v-model="ruleForm.resDepId" placeholder="请选择部门" style="width: 100%"
                                       @change="departChange">
                                <el-option v-for="item in departList" :key="item.id" :label="item.name"
                                           :value="item.id"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="岗位" prop="resJobId">
                            <el-select v-model="ruleForm.resJobId" placeholder="请选择岗位" style="width: 100%"
                                       @change="jobChange">
                                <el-option v-for="item2 in jobList" :key="item2.id" :label="item2.name"
                                           :value="item2.id"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label-width="0" style="margin-bottom: 0">
                    <el-col :span="12">
                        <el-form-item label="员工" prop="resEmpId">
                            <el-select v-model="ruleForm.resEmpId" placeholder="请选择员工" style="width: 100%"
                                       @change="ResEmpChange">
                                <el-option v-for="item3 in resEmpList" :key="item3.id" :label="item3.name"
                                           :value="item3.id"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="年度" prop="yeas">
                            <el-date-picker
                                    v-model="ruleForm.yeas"
                                    type="year"
                                    value-format="yyyy"
                                    style="width: 100%"
                                    placeholder="选择年"/>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input type="textarea" :rows="3" v-model="ruleForm.remarks" placeholder="请输入指标内容"/>
                </el-form-item>
                <el-form-item label-width="0" style="margin-bottom: 0">
                    <el-col :span="12">
                        <el-form-item label="制定人" prop="proEmpId">
                            <el-select
                                    v-model="ruleForm.proEmpId"
                                    placeholder="请选择制定人"
                                    style="width: 100%"
                                    @change="user($event, 1)"
                            >
                                <el-option v-for="item4 in allEmpList" :key="item4.id" :label="item4.name"
                                           :value="item4.id"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="制定日期" prop="proTime">
                            <el-date-picker
                                    v-model="ruleForm.proTime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="date"
                                    placeholder="选择日期时间"
                                    style="width: 100%"
                            />
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label-width="0" style="margin-bottom: 0">
                    <el-col :span="12">
                        <el-form-item label="预定考核时间" prop="checkTime">
                            <el-date-picker
                                    v-model="ruleForm.checkTime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="date"
                                    placeholder="选择日期时间"
                                    style="width: 100%"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="考核标准" prop="checkNorm">
                            <el-input v-model="ruleForm.checkNorm" type="number" placeholder="请输入分数"/>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label-width="0" style="margin-bottom: 0">
                    <el-col :span="12">
                        <el-form-item label="考核人" prop="checkEmpId">
                            <el-select
                                    v-model="ruleForm.checkEmpId"
                                    placeholder="请选择考核人"
                                    style="width: 100%"
                                    @change="user($event, 2)"
                            >
                                <el-option v-for="item5 in allEmpList" :key="item5.id" :label="item5.name"
                                           :value="item5.id"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <!-- <el-form-item prop="definitionId" label="流程模板" v-if="!$route.params.id">
                  <el-select :disabled="$route.params.id ? true : false" v-model="ruleForm.definitionId"
                  placeholder="请添加" style="width:100%" @change="modelChange">
                    <el-option
                      v-for="m in modules"
                      :key="m.id"
                      :label="m.name"
                      :value="m.definitionId"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')" style="width: 100%">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {
        getResponseBookList, getAllDepartment, getDepartUser, personalResponseAdd, getStaffList, personalResponseEdit,
        getEmpListByJobId
    } from "@/api/processManager";
    import {modulesList} from "@/api/model.js"

    export default {
        name: "mainTargetAdd",
        data() {
            return {
                // 岗位责任书列表
                responsibleJobList: [],
                // 部门列表
                departList: [],
                // 岗位列表
                jobList: [],
                // 岗位下面人员的列表
                resEmpList: [],
                // 人员的列表
                userList: [],
                // 所有员工列表
                allEmpList: [],
                typeList: [
                    {id: 0, name: '年度目标'},
                    {id: 1, name: '季度目标'},
                    {id: 2, name: '月度目标'},
                ],
                // 表单数据
                ruleForm: {},
                rules: {
                    resTitle: [{required: true, message: '请选择责任书'}],
                    resDepId: [{required: true, message: '请选择部门'}],
                    resJobId: [{required: true, message: '请选择岗位', trigger: 'blur'}],
                    yeas: [{required: true, message: '请选择年度'}],
                    proEmpId: [{required: true, message: '请选择制定人'}],
                    resEmpId: [{required: true, message: '请选择员工', trigger: 'blur'}],
                    proTime: [{required: true, message: '请选择制定日期'}],
                    checkNorm: [{required: true, message: '请输入标准分数', trigger: 'blur'}],
                    checkEmpId: [{required: true, message: '请选择考核人'}],
                    checkTime: [{required: true, message: '请选择预定考核时间'}],
                    definitionId: [{required: true, message: '请选择'}]
                },
                modules: []
            };
        },
        created() {
            this.getResponseBookList();
            this.getDepart();
            this.getAllEmp();
            this.getModulesList()
            if (this.$route.params.id) {
                let obj = this.$route.params
                delete (obj.signTime);
                delete (obj.signFileName);
                delete (obj.signFileUrl);
                delete (obj.jobResFileUrl);
                delete (obj.checkUserId)
                delete (obj.gmtCreate)
                // delete(obj.depAuditStatus)
                this.ruleForm = obj
                let id = Number(obj.resDepId)
                getAllDepartment().then(res => {
                    this.departList = res.body.data;
                    for (let i in this.departList) {
                        if (this.departList[i].id === id) {
                            this.jobList = this.departList[i].jobVos
                        }
                    }
                })
                getEmpListByJobId({jobId: obj.resJobId}).then(res => {
                    this.resEmpList = res.body.data
                })
            }
        },
        methods: {
            // 获取所有的岗位责任书
            getResponseBookList() {
                getResponseBookList({limit: 1000, curPage: 1}).then(res => {
                    this.responsibleJobList = res.body.data;
                })
            },
            // 获取所有部门
            getDepart() {
                getAllDepartment().then(res => {
                    this.departList = res.body.data;
                })
            },
            // 获取所有员工列表
            getAllEmp() {
                getStaffList({}).then(res => {
                    this.allEmpList = res.body.data
                })
            },
            // 岗位责任书改变
            responseJobChange(id) {
                let obj = this.responsibleJobList.find((item => {
                    return item.id === id
                }))
                this.ruleForm.resTitle = obj.resTitle
            },
            // 部门改变
            departChange(id) {
                let obj = this.departList.find((item => {
                    return item.id === id
                }))
                this.ruleForm.resJobId = '',
                    this.ruleForm.resEmpId = ''
                this.ruleForm.resDepName = obj.name
                this.jobList = obj.jobVos
            },
            // 岗位改变
            jobChange(id) {
                let obj = this.jobList.find((item) => {
                    return item.id === id
                })
                this.ruleForm.resEmpId = '';
                this.ruleForm.resEmpName = '';
                getEmpListByJobId({jobId: id}).then(res => {
                    this.resEmpList = res.body.data
                })
                this.ruleForm.resJobName = obj.name
                this.$forceUpdate()
            },
            // 员工改变
            ResEmpChange(id) {
                let obj = {}
                obj = this.resEmpList.find((item) => {
                    return item.id === id
                })
                this.ruleForm.resEmpName = obj.name
                this.$forceUpdate()
            },
            user(id, status) {
                let obj = this.allEmpList.find((item => {
                    return item.id === id
                }))
                if (status === 1) {
                    this.ruleForm.proName = obj.name
                }
                if (status === 2) {
                    this.ruleForm.checkEmpName = obj.name
                }
                this.$forceUpdate();
            },
            // 获取部门下面的人员
            getUser(id) {
                getDepartUser({demId: id}).then(res => {
                    this.ruleForm.departmentHeadEmpid = ''
                    this.ruleForm.producerEmpId = ''
                    this.userList = res.body.data;
                })
            },
            // 上传的事件
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },

            getModulesList() {
                modulesList().then(res => {
                    this.modules = res.body.data
                })
            },

            // 模板更改
            modelChange(a) {
                let obj = {}
                obj = this.modules.find(v => {
                    return a === v.definitionId
                })
                this.ruleForm.key = obj.key
                // console.log(this.form)
            },

            // 保存的按钮
            submitForm() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        let obj = {...this.ruleForm}
                        // obj.examinedContent = JSON.stringify(this.tableData);
                        if (this.$route.params.id) {
                            obj.proTime = this.ruleForm.proTime
                            personalResponseEdit({...obj}).then(res => {
                                this.$message.success('编辑成功');
                                this.$router.back();
                            })
                        } else {
                            personalResponseAdd({...obj}).then(res => {
                                this.$message.success('添加成功');
                                this.$router.back();
                            })
                        }
                    } else {
                        return false;
                    }
                });
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    };
</script>

<style scoped>
    .formBox {
        padding-top: 15px;
        padding-right: 10%;
        width: 70%;
        margin: auto;
    }

    .formBox /deep/ .el-form-item {
        margin-bottom: 25px;
    }
</style>
